import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { AppServiceService } from '../service/app-service.service';

import { DeptService } from '../service/dept.service';
import { DeptListing } from '../shared/models/dept-listing';


@Component({
  selector: 'app-dept-listing-detail',
  templateUrl: './dept-listing-detail.component.html',
  styleUrls: ['./dept-listing-detail.component.css']
})

export class DeptListingDetailComponent implements OnInit {

  departments: DeptListing[];
  searchValue: string;
    
  constructor (
	private deptService: DeptService, 
	private router: Router, 
	private appService: AppServiceService,
	private activatedRoute: ActivatedRoute) {
		
		this.activatedRoute.params.subscribe(params => {
      		this.searchValue = params['searchOID'];
      		this.getDeptDetail(this.searchValue) ;      		
      	});
		
	 }
	 

  ngOnInit(): void {
	
		this.appService.setTitle('Search Departments');
		
		this.router.events.subscribe ((evt) => {
			if (!(evt instanceof NavigationEnd)) {
				return;
			}
			window.scrollTo(0,0)
		});
		
  }


  getDeptDetail (filter: String) {

	this.deptService.getDeptDetail (filter) 
	  .subscribe ( data => {
		  this.departments = data
	  },
	  (err: HttpErrorResponse) => {
		if (err.error instanceof Error) {
			console.log ('an error occured',err.error.message);
		} else {
			console.log('backend returned status code ',err.status);
		}
		
	});

  }
  
    

}
